import PageHeader from 'components/pageHeader/PageHeader';
import { Trans, useTranslation } from 'react-i18next';
import AddCustomFieldButton from '../add/AddCustomFieldButton';

const CustomFieldsTabHeader = () => {
  const { t } = useTranslation();

  return (
    <PageHeader
      title={t('pageAutomations.customFields.title')}
      subtitle={
        <Trans
          i18nKey="pageAutomations.customFields.subtitle"
          components={{
            link1: (
              <a
                aria-label="Hostfully documentation"
                href="https://help.hostfully.com/en/articles/2762015-define-and-use-custom-data"
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
      buttons={<AddCustomFieldButton />}
      noDivider
    />
  );
};

export default CustomFieldsTabHeader;
